import type { JSONContent } from '@sequencehq/core-components'
import type {
  QuoteBlockAlignment,
  TextBlockConfig
} from '@sequencehq/quote-content'
import { match } from 'ts-pattern'

type TextBlockAttributes = Pick<
  TextBlockConfig,
  'textAlignment' | 'textColor' | 'backgroundColor'
>

/**
 * Missing alignment and colours load as their defaults, so an untouched block
 * saves back the same. There's no justify, so justified text loads left
 * aligned.
 */
export const textBlockAttributesIn = (
  config: TextBlockAttributes | undefined
) => ({
  textAlign: alignmentIn(config?.textAlignment),
  textColor: config?.textColor ?? 'default',
  backgroundColor: config?.backgroundColor ?? 'default'
})

/**
 * Alignment and colours are always written, even when they're the defaults,
 * to match what existing quotes have saved.
 */
export const textBlockAttributesOut = (
  attrs: JSONContent['attrs']
): Required<TextBlockAttributes> => ({
  textAlignment: attrs?.textAlign ?? 'left',
  textColor: attrs?.textColor ?? 'default',
  backgroundColor: attrs?.backgroundColor ?? 'default'
})

/** There's no justify, so justified content loads left aligned. */
export const alignmentIn = (alignment: QuoteBlockAlignment | undefined) =>
  match(alignment)
    .with('center', 'right', value => value)
    .otherwise(() => 'left')
